interface EnvConfig {
  API_URL: string;
  ENABLE_API_LOGS: boolean;
  NODE_ENV: string;
  TENANT_URL: string;
}

const envConfig: EnvConfig = {
  API_URL: process.env.REACT_APP_API_URL || "",
  ENABLE_API_LOGS: process.env.REACT_APP_ENABLE_API_LOGS === "true" || process.env.NODE_ENV === "development",
  NODE_ENV: process.env.NODE_ENV || "development",
  TENANT_URL: process.env.REACT_APP_TENANT_URL || "",
};

const requiredVars: Array<{ key: keyof EnvConfig; envKey: string; description: string }> = [
  { key: "API_URL", envKey: "REACT_APP_API_URL", description: "Backend API base URL" },
];

export function validateFrontendEnv(): EnvConfig {
  const warnings: string[] = [];

  for (const { envKey, description } of requiredVars) {
    if (!process.env[envKey] || process.env[envKey]?.trim() === "") {
      warnings.push(`Missing: ${envKey} — ${description}`);
    }
  }

  if (!process.env.REACT_APP_TENANT_URL) {
    warnings.push("Missing: REACT_APP_TENANT_URL — Tenant subdomain URL");
  }

  if (process.env.NODE_ENV !== "production") {
    if (warnings.length > 0) {
      console.warn("[ENV] ⚠️  Environment warnings:");
      warnings.forEach((w) => console.warn(`[ENV]   ${w}`));
    }
    console.info(`[ENV] API_URL: ${envConfig.API_URL || "(empty)"}`);
    console.info(`[ENV] NODE_ENV: ${envConfig.NODE_ENV}`);
    console.info(`[ENV] ENABLE_API_LOGS: ${envConfig.ENABLE_API_LOGS}`);
  }

  return envConfig;
}

export default validateFrontendEnv();
